import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { MainContext } from "../../context/mainContext";
import { Cookies } from "../../utils/cookies";

const Menu = ({ menuOpened, setMenuOpened }) => {
  const { isAuth, setIsAuth } = useContext(MainContext);

  return (
    <div className={`menu ${menuOpened ? "open" : "close"}`}>
      {isAuth ? (
        <div>
          {/* <div className="menu-item" onClick={() => setMenuOpened(false)}>
                <NavLink activeClassName="active-link" to="/home/1" style={{textDecoration: "none"}} ><span>SANA ÖZEL</span></NavLink>
            </div> */}
          <div className="menu-item" onClick={() => setMenuOpened(false)}>
            <NavLink
              activeClassName="active-link"
              to="/home"
              style={{ textDecoration: "none" }}
            >
              <span className="menu-item-text">VİDEO</span>
            </NavLink>
          </div>
          <div
            className="menu-item"
            onClick={() => {
              setMenuOpened(false);
              setIsAuth(false);
              Cookies.remove("token", { path: "/" });
              localStorage.removeItem("relatedId");
              localStorage.removeItem("discoverId");
            }}
          >
            <NavLink
              activeClassName="active-link"
              to="/login"
              style={{ textDecoration: "none" }}
            >
              <span className="menu-item-text">ÇIKIŞ YAP</span>
            </NavLink>
          </div>
        </div>
      ) : (
        <div className="menu-item" onClick={() => setMenuOpened(false)}>
          <NavLink
            activeClassName="active-link"
            to="/login"
            style={{ textDecoration: "none" }}
          >
            <span>Giriş Yap</span>
          </NavLink>
        </div>
      )}
    </div>
  );
};

export default Menu;
